// 개선된 HTML Include 시스템
class HTMLInclude {
    constructor() {
        this.cache = new Map();
        this.loading = new Set();
    }

    async loadFile(url) {
        // 캐시에서 확인
        if (this.cache.has(url)) {
            return this.cache.get(url);
        }

        // 이미 로딩 중인 경우 대기
        if (this.loading.has(url)) {
            while (this.loading.has(url)) {
                await new Promise(resolve => setTimeout(resolve, 10));
            }
            return this.cache.get(url);
        }

        this.loading.add(url);
        
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            
            const html = await response.text();
            this.cache.set(url, html);
            return html;
        } catch (error) {
            return `<div class="include-error">Failed to load: ${url}</div>`;
        } finally {
            this.loading.delete(url);
        }
    }

    async includeHTML() {
        const elements = document.querySelectorAll('[data-include]:not([data-include-processed])');
        
        const promises = Array.from(elements).map(async (element) => {
            const url = element.getAttribute('data-include');
            if (!url) return;

            element.setAttribute('data-include-processed', 'true');
            
            try {
                const html = await this.loadFile(url);
                element.innerHTML = html;
                element.removeAttribute('data-include');
                
                // 새로 삽입된 HTML에서 스크립트 실행
                this.executeScripts(element);
                
                // 중첩된 include 처리
                const nestedIncludes = element.querySelectorAll('[data-include]');
                if (nestedIncludes.length > 0) {
                    await this.includeHTML();
                }
            } catch (error) {
                element.innerHTML = `<div class="include-error">Error loading: ${url}</div>`;
            }
        });

        await Promise.all(promises);
    }

    executeScripts(container) {
        const scripts = container.querySelectorAll('script');
        scripts.forEach(script => {
            const newScript = document.createElement('script');
            newScript.textContent = script.textContent;
            if (script.src) newScript.src = script.src;
            document.head.appendChild(newScript);
            script.remove();
        });
    }

    // 자동 초기화
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.includeHTML());
        } else {
            this.includeHTML();
        }
    }
}

// 전역 인스턴스 생성
const htmlInclude = new HTMLInclude();

// 자동 초기화
htmlInclude.init();

// 수동 호출을 위한 전역 함수
window.includeHTML = () => htmlInclude.includeHTML();